import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import firebaseConfig from "./firebase-applet-config.json";

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios y bandera de confirmación
export const auth = getAuth(app);
// Blindaje: la base de datos de producción queda fija en código, inmune a que la plataforma
// reescriba firestoreDatabaseId en firebase-applet-config.json.
export const db = getFirestore(app, "(default)");
export const legacyDb = getFirestore(app, "ai-studio-b3b865f3-ee63-4eb3-90b4-45fb4ac356dd"); // USA Legacy
export const getDefaultDb = () => getFirestore(app, "(default)");

// Esta bandera indica que las claves están puestas
export const isFirebaseConfigured = true;

export default app;
